export default "__VITE_PUBLIC_ASSET__dfa3488e__"